import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { useState } from "react";
import ProfileCard from "../../../../components/ContactInfo/ProfileCard";
import FormSetup from "../../../../components/Forms/FormSetup";
import { Typography, Space, Button } from "antd";
const { Text } = Typography;

const EvaluationInProcess = () => {
  const [open, setOpen] = useState(false);
  const [confirmEmploymentOpen, setConfirmEmploymentOpen] = useState(false);

const handleOpenModal = (feedbackStatus: string) => {
    if (feedbackStatus === "Bad" || feedbackStatus === "Average") {
      setOpen(true); 
    } else if (feedbackStatus === "Good" || feedbackStatus === "Very Good") {
      setConfirmEmploymentOpen(true); 
    }
  };

  const config: MasterConfigs = {
    api: () => "/evaluationInProgress",
    modalTitle: () => "Extend Probation",
    getFormColumns: () => [
      {
        type: "custom",
        formItem: () => (
          <ProfileCard
            avatarUrl="https://png.pngtree.com/png-clipart/20200224/original/pngtree-cartoon-color-simple-male-avatar-png-image_5230557.jpg"
            name="Ajay kumar"
            role="Ag-32323"
          />
        ),
        span: 24,
      },
      {
        type: "custom",
        formItem: () => (
          <Text>
            In Probation since <Text strong>12 Oct 2024</Text>
          </Text>
        ),
        span: 24,
      },
      {
        type: "custom",
        formItem: () => (
          <Space direction="horizontal">
            <Text>
              In Probation since <Text strong>12 Oct 2024</Text>
            </Text>
            <Button type="link" size="small">
              View Feedback
            </Button>
          </Space>
        ),
        span: 24,
      },
      {
        type: "custom",
        formItem: () => (
          <Text>
            Probation Extended before 1 time for{" "}
            <Text strong>31 Dec 2024 to 30 Jan 2025</Text>
          </Text>
        ),
        span: 24,
      },
      {
        type: "date",
        name: "ExtendProbationTill",
        label: "Extend Probation till",
        rules: [{ required: true, message: "This field is required" }], 
        dateProps: {
          type: "date",
          format: "DD-MM-YYYY",
        },
        span: 8,
      },
      {
        type: "checkbox",
        name: "sendForTermination",
        label: "Send for termination",
        span: 24,
      },
    ],

    getColumns: () => [
      {
        title: "Employee Name",
        dataIndex: ["userId", "firstName"],
        key: "firstName",
        render: (_: string, record: any) => {
          const { userId } = record;
          if (!userId) return "N/A";

          const { firstName, lastName } = userId;
          return (
            <div>
              <div>{`${firstName || ""} ${lastName || ""}`}</div>
              <div style={{ fontSize: "0.60rem", color: "gray" }}>
                {userId.employeeId}
              </div>
            </div>
          );
        },
      },
      {
        title: "Email",
        dataIndex: ["userId", "email"],
        key: "email",
        align: "center",
      },
      {
        title: "Department",
        dataIndex: ["userId", "department", "name"],
        key: "department",
        align: "center",
        render: (_: string, record: any) => {
          const department = record?.userId?.department;
          return department ? department.name : "N/A";
        },
      },
      {
        title: "Location",
        dataIndex: ["userId", "location", "name"],
        key: "location",
        align: "center",
        render: (_: string, record: any) => {
          const location = record?.userId?.location;
          return location ? location.name : "N/A";
        },
      },
      {
        title: "Probation End Date",
        dataIndex: ["userId", "probationEndDate"],
        key: "probationEndDate",
        align: "center",
        render: (date: string) => {
          const endDate = new Date(date);
          const currentDate = new Date();
          const timeDiff = endDate.getTime() - currentDate.getTime();
          const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));

          const formattedDate = endDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });

          return (
            <>
              <div>{formattedDate}</div>
              <div style={{ fontSize: "0.70rem", color: "gray" }}>
                {daysRemaining > 0 ? `${daysRemaining} days Balance` : "Ended"}
              </div>
            </>
          );
        },
      },
      {
        title: "Start Evaluation Date",
        dataIndex: "startEvaluationDate",
        key: "startEvaluationDate",
        align: "center",
        render: (date) => {
          const formattedDate = new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
          return formattedDate;
        },
      },

      {
        title: "Feedback Receive",
        dataIndex: ["feedbackStatus"],
        key: "feedbackStatus",
        align: "center",
        render: (_: string, record: any) => {
          return record?.feedbackStatus || "N/A";
        },
      },
      {
        title: "Actions",
        key: "actions",
        align: "center",
        render: (_: any, record: any) => (
          <Button type="link" onClick={() => handleOpenModal(record.feedbackStatus)}>
          {record.feedbackStatus === "Bad" || record.feedbackStatus === "Average"
            ? "Extend Probation"
            : "Confirm Employment"}
        </Button>
          
        ),
      },
    ],
  };

  return (
    <div>
      <HeadingSubHeading title="Evaluation Progress" subTitle="Track Evaluation Progress" />
      <MasterComponent config={config} />
      <FormSetup open={open} config={config} onClose={() => setOpen(false)} isModal={true} />
      <FormSetup
        open={confirmEmploymentOpen}
        config={{
          modalTitle: () => "Confirm Employment",
          getFormColumns: () => [
            {
              type: "custom",
              formItem: () => (
                <ProfileCard
                  avatarUrl="https://png.pngtree.com/png-clipart/20200224/original/pngtree-cartoon-color-simple-male-avatar-png-image_5230557.jpg"
                  name="Ajay kumar"
                  role="Ag-32323"
                />
              ),
              span: 24,
            },
            {
              type: "custom",
              formItem: () => (
                <Text>
                  In Probation since <Text strong>12 Oct 2024</Text>
                </Text>
              ),
              span: 24,
            },
            {
              type: "custom",
              formItem: () => (
                <Space direction="horizontal">
                  <Text>
                    In Probation since <Text strong>12 Oct 2024</Text>
                  </Text>
                  <Button type="link" size="small">
                    View Feedback
                  </Button>
                </Space>
              ),
              span: 24,
            },
            {
              type: "custom",
              formItem: () => (
                <Text>
                  Probation Extended before 1 time for{" "}
                  <Text strong>31 Dec 2024 to 30 Jan 2025</Text>
                </Text>
              ),
              span: 24,
            },
            {
              type: "date",
              name: "ExtendProbationTill",
              label: "Confirm Employment from",
              rules: [{ required: true, message: "This field is required" }], 
              dateProps: {
                type: "date",
                format: "DD-MM-YYYY",
              },
              span: 8,
            },
            {
              type: "checkbox",
              name: "sendForTermination",
              label: "Send for termination",
              span: 24,
            },
          ],
        }}
        onClose={() => setConfirmEmploymentOpen(false)}
        isModal={true}
      />
    </div>
  );
};

export default EvaluationInProcess;
